import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b046290"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Name", -1))
const _hoisted_3 = {
  key: 0,
  class: "data-field"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Name", -1))
const _hoisted_5 = {
  key: 1,
  class: "data-field"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Vorname", -1))
const _hoisted_7 = {
  key: 2,
  class: "data-field"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nachname", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Telefonnummern", -1))
const _hoisted_10 = { class: "data-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nummer", -1))
const _hoisted_12 = { class: "data-field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "WhatsApp", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "E-Mail-Adresse", -1))
const _hoisted_15 = { class: "data-field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "E-Mail", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_modal = _resolveComponent("md-modal")!

  return (_openBlock(), _createBlock(_component_md_modal, {
    ref: "modal",
    title: "Kontakt ansehen",
    icon: "person"
  }, {
    default: _withCtx(() => [
      _createTextVNode(" Hier werden dir alle Details des Kontakts angezeigt. ")
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.contact.name.formatted_name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("b", null, _toDisplayString(_ctx.contact.name.formatted_name), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.contact.name.first_name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("b", null, _toDisplayString(_ctx.contact.name.first_name), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.contact.name.last_name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("b", null, _toDisplayString(_ctx.contact.name.last_name), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.contact.phones && _ctx.contact.phones.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _hoisted_9,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contact.phones, (phone, k) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "data-group",
                  key: k
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("b", null, _toDisplayString(phone.phone), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("b", null, _toDisplayString(!!phone.wa_id ? "Ja" : "Nein"), 1)
                  ])
                ]))
              }), 128))
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.contact.emails && _ctx.contact.emails.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _hoisted_14,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contact.emails, (email, k) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "data-group",
                  key: k
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("b", null, _toDisplayString(email.email), 1)
                  ])
                ]))
              }), 128))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_md_button, {
        variant: "text",
        grey: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Schließen")
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}